import {Params} from '@angular/router';

export interface ErrorPageParams {
    uri?: string;
    requestId?: string;
    errorHint?: string;
    errorCode?: string;
}

export const mapParamsToErrorPage = (params: Params, errorUri?: string): ErrorPageParams => ({
  uri: errorUri,
  requestId: params.requestId,
  errorCode: params.error_code,
  errorHint: params.error_hint
});

export const errorPageParamsToUrl = (errorPageParams: ErrorPageParams): URL => {
  if (!errorPageParams.uri) {
    throw new Error(`uri property is empty for params: ${JSON.stringify(errorPageParams)}`);
  }
  const url = new URL(errorPageParams.uri);
  if (errorPageParams.errorHint) {
    url.searchParams.append('error_hint', errorPageParams.errorHint);
  }
  if (errorPageParams.errorCode) {
    url.searchParams.append('error_code', errorPageParams.errorCode);
  }
  if (errorPageParams.requestId) {
    url.searchParams.append('requestId', errorPageParams.requestId);
  }
  return url;
};

export const errorPageParamsToQueryParams = (errorPageParams: ErrorPageParams): Params => ({
  ...(errorPageParams.errorHint && {error_hint: errorPageParams.errorHint} || {}),
  ...(errorPageParams.errorCode && {error_code: errorPageParams.errorCode} || {}),
  ...(errorPageParams.requestId && {requestId: errorPageParams.requestId} || {}),
});
